"use client";

import React from "react";
import { ReactSVG } from "react-svg";
import { SSO_PROVIDER, SsoProviderId } from "../types";

const SSO_GOOGLE_SIGNIN_ICON_SRC = "/svg/google-icon.svg" as const;
const SSO_APPLE_SIGNIN_ICON_SRC = "/svg/apple-icon.svg" as const;
const SSO_MICROSOFT_SIGNIN_ICON_SRC = "/svg/microsoft-icon.svg" as const;

const GoogleSSOIcon = () => (
  <ReactSVG
    className="sso-auth-button__icon-svg"
    src={SSO_GOOGLE_SIGNIN_ICON_SRC}
  />
);

const AppleSSOIcon = () => (
  <ReactSVG
    className="sso-auth-button__icon-svg"
    src={SSO_APPLE_SIGNIN_ICON_SRC}
  />
);

const MicrosoftSSOIcon = () => (
  <ReactSVG
    className="sso-auth-button__icon-svg"
    src={SSO_MICROSOFT_SIGNIN_ICON_SRC}
  />
);

export interface SsoProviderIconProps {
  provider: SsoProviderId;
}

export const SsoProviderIcon = ({ provider }: SsoProviderIconProps) => {
  const logos = {
    [SSO_PROVIDER.GOOGLE]: <GoogleSSOIcon />,
    [SSO_PROVIDER.APPLE]: <AppleSSOIcon />,
    [SSO_PROVIDER.MICROSOFT]: <MicrosoftSSOIcon />,
  };

  return logos[provider] || null;
};
